import React from 'react';
import './css/style.css';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// Keep these in sync with the "/About" entry in SeoPageRenderer.cs
const PAGE_URL = "https://www.dysband.com/About";
const PAGE_TITLE = "About Dirty Yachtin' Scoundrels | Phoenix Yacht Rock Band";
const PAGE_DESCRIPTION =
    "Learn about Dirty Yachtin' Scoundrels, a Phoenix-based yacht rock band playing smooth '70s and '80s hits at events nationwide.";
const PAGE_IMAGE =
    "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp";

const About = () => { // (Arrow Function Declaration)
    return (
        <div className="backer">
            <Helmet>
                <title>{PAGE_TITLE}</title>
                <meta name="description" content={PAGE_DESCRIPTION} />
                <link rel="canonical" href={PAGE_URL} />

                <meta property="og:title" content={PAGE_TITLE} />
                <meta property="og:description" content={PAGE_DESCRIPTION} />
                <meta property="og:url" content={PAGE_URL} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />
                <meta property="og:image" content={PAGE_IMAGE} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={PAGE_TITLE} />
                <meta name="twitter:description" content={PAGE_DESCRIPTION} />
                <meta name="twitter:image" content={PAGE_IMAGE} />
            </Helmet>

            <div className="col-12 bio">
                <h1 className="bio_span">About Dirty Yachtin' Scoundrels</h1>
                <p className="bio_span">
                    Introducing Dirty Yachtin' Scoundrels: This dynamic band effortlessly sets sail on the nostalgic waves of the '70s and '80s, where soft rock and breezy melodies reign supreme. Embarking on a musical journey that captures the essence of an era, Dirty Yachtin' Scoundrels expertly blends smooth harmonies, lush instrumentation, and irresistible hooks to create their signature sound.
                </p>
                <p className="bio_span">
                    So come aboard and set sail with Dirty Yachtin' Scoundrels. Let the mellow grooves and irresistible melodies carry you away to an era of effortless cool and eternal summer. Get ready to embark on a musical journey that will transport you to the golden age of yacht rock and leave you longing for those endless days on the open water.
                </p>
                <p className="bio_span">
                    Dirty Yachtin' Scoundrels is based in Phoenix, Arizona, and performs at weddings, corporate events, private parties, festivals, and public shows in the Phoenix area, across Arizona, and nationwide. Meet the musicians on the <Link to="/BioPage">band page</Link>, see the <Link to="/Calendar">upcoming shows</Link>, or <Link to="/Contact">get in touch</Link> about booking.
                </p>
            </div>
        </div>
    );
}
export default About